<template>
  <section class="admin-layout-container">
    <div class="layout">
      <Layout>
        <Sider ref="sidebar" class="sidebar" hide-trigger collapsible width="230" :collapsed-width="78"
               v-model.trim="isCollapsed">
          <div class="logo">
            <router-link replace to="/systemUserInfo">
              <div class="xfind-line" v-if="!isCollapsed">
                <div class="line-h"></div>
              </div>
              <div v-if="!isCollapsed" class="logo-saiqu">
                <!--<Avatar v-if="$store.state.systemUser != null" :src="$store.state.systemUser.imageUrl" style="border: 2px solid #fff" icon="ios-person"-->
                        <!--size="large"/>-->
                <Avatar v-if="currentUser != null" :src="currentUser.imageUrl" style="border: 2px solid #fff" icon="ios-person"
                        size="large"/>
                <span class="user-name">
                                {{ currentUser == undefined ? '': currentUser.loginName }}
                            </span>
              </div>
              <Avatar v-if="currentUser != null && isCollapsed" :src="currentUser.imageUrl" icon="ios-person" size="large"/>
            </router-link>
          </div>
          <Menu
            ref="side_menu"
            :active-name="activeMenuName"
            :open-names="openMenuName"
            theme="light"
            width="230px"
            :class="menuitemClasses"
            @on-select="choosedMenu"
            v-if="!isCollapsed">
            <template v-for="(menu,menu_index) in menus">
              <Submenu :name="menu.name" v-if="menu.children && menu.enable" :key="menu_index">
                <template slot="title">
                  <Icon :size="20" :type="menu.icon"></Icon>
                  <span>{{menu.title}}</span>
                </template>
                <MenuItem :name="child.name" v-for="(child ,child_index) in menu.children" :key="child_index" v-if="child.enable">
                  <Icon :size="20" :type="child.icon"></Icon>
                  <span>{{child.title}}</span>
                </MenuItem>
              </Submenu>
              <MenuItem :name="menu.name" v-if="!menu.children && menu.showInMenus && menu.enable" :key="menu_index">
                <Icon :size="20" :type="menu.icon" :key="menu_index"></Icon>
                <span>{{menu.title}}</span>
              </MenuItem>
            </template>
          </Menu>
          <div class="dropdown-wrap" v-if="isCollapsed">
            <div class="dw-content">
              <template v-for="(menu,menu_index) in menus">
                <Dropdown transfer placement="right-start" v-if="menu.children && menu.enable" @on-click="dropdownClick"
                          :key="menu_index">
                  <Button class="dd-btn" type="text">
                    <Icon :size="25" :type="menu.icon"></Icon>
                  </Button>
                  <DropdownMenu class="dd-menu" slot="list">
                    <template v-for="(child, i) in menu.children">
                      <DropdownItem :name="child.name" :key="i" v-if="child.enable">
                        <div class="ddi-wapper">
                          <Icon :size="16" :type="child.icon"></Icon>
                          <span class="ddi-text">
                                                    {{ child.title }}
                                                </span>
                        </div>
                      </DropdownItem>
                    </template>
                  </DropdownMenu>
                </Dropdown>
                <Dropdown transfer v-if="!menu.children && menu.showInMenus && menu.enable" placement="right-start"
                          @on-click="dropdownClick" :key="menu_index">
                  <Button class="dd-btn" type="text">
                    <Icon :size="25" :type="menu.icon"></Icon>
                  </Button>
                  <DropdownMenu class="dd-menu" slot="list">
                    <DropdownItem :name="menu.name">
                      <div class="ddi-wapper">
                        <Icon :size="16" :type="menu.icon"></Icon>
                        <span class="ddi-text">
                                                {{ menu.title }}
                                            </span>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </template>
            </div>
          </div>
        </Sider>
        <Layout>
          <!-- :style="{width: isCollapsed?'calc(100% - 78px)':'calc(100% - 230px)'}" -->
          <Header class="layout-header-bar">
            <div class="header-wapper">
              <div class="header-left">
                <Icon @click.native="collapsedSider" :class="rotateIcon" type="md-menu" size="28"></Icon>
                <span class="header-title">食疗后台管理系统</span>
              </div>
              <div class="header-right">
                <router-link replace to="/systemUserInfo">
                  <Button type="text" icon="ios-contact" style="color: white" size="large">个人中心</Button>
                </router-link>
                <Dropdown v-if="currentUser != null && currentUser.role && currentUser.length > 1">
                  <!--<Dropdown v-if="$store.state.systemUser != null && $store.state.systemUser.role && $store.state.systemUser.role.length > 1">-->
                  <Button type="text" icon="ios-browsers" style="color: white" size="large">
                    系统切换
                    <Icon type="ios-arrow-down"></Icon>
                  </Button>
                  <DropdownMenu slot="list">
                    <DropdownItem><router-link replace to="/main">管理员系统</router-link></DropdownItem>
                    <DropdownItem><router-link replace to="/doctor_manage">医生系统</router-link></DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Button type="text" icon="md-exit" class="btn-blue" size="large" @click="quit">退出系统</Button>
              </div>
            </div>
          </Header>
          <!-- :style="{width:isCollapsed?'calc(100% - 78px)':'calc(100% - 230px)'}" -->
          <Content class="main-content">
            <Layout class="main-layout-con">
              <div class="tags-nav-wapper">
                <div class="tags-nav">
                  <div class="btn-con left-btn">
                    <Button type="text" @click="handleScroll(240)">
                      <Icon :size="18" type="ios-arrow-back"/>
                    </Button>
                  </div>
                  <div ref="scrollOuter" class="scroll-outer" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll">
                    <div ref="scrollBody" class="scroll-body" :style="{left: tagBodyLeft + 'px'}">
                      <transition-group name="taglist-moving-animation">
                        <Tag type="dot"
                             v-for="tab in tags"
                             :closable="tab.closable"
                             :color="tab.choosed? 'primary':'#e9eaec'"
                             :name="tab.name"
                             @click.native="clickTag(tab)"
                             @on-close="closeTag"
                             :key="tab.name">
                          {{tab.title}}
                        </Tag>
                      </transition-group>
                    </div>
                  </div>
                  <div class="btn-con right-btn">
                    <Button type="text" @click="handleScroll(-240)">
                      <Icon :size="18" type="ios-arrow-forward"/>
                    </Button>
                  </div>
                </div>
              </div>
              <Content class="content-wrapper">
                <!--<keep-alive>-->
                <router-view/>
                <!--</keep-alive>-->
              </Content>
            </Layout>
          </Content>
        </Layout>
      </Layout>
    </div>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        isCollapsed: false,
        // ------------------------------  菜单操作开始  --------------------------------
        title: '首页',
        activeMenuName: 'admin',
        currentUser: null,
        openMenuName: [],
        tagBodyLeft: 0,
        rightOffset: 40,
        outerPadding: 4,
        contextMenuLeft: 0,
        contextMenuTop: 0,
        visible: false,
        menus: [
          {
            title: '首页',
            num: 1,
            name: 'admin',
            icon: 'ios-home',
            href: '/home',
            closable: false,
            showInTags: true,
            showInMenus: true,
            enable: true,
            choosed: true
          },
          {
            title: '食材管理',
            name: 'food',
            icon: 'ios-nutrition',
            enable: false,
            children: [
              {
                title: '食材类别',
                name: 'foodMaterialType',
                href: '/main/foodMaterialType',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'foodMaterialType:list'
              },
              {
                title: '基础食材',
                name: 'foodMaterial',
                href: '/main/foodMaterial',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'foodMaterial:list'
              },
              {
                title: '营养物质',
                name: 'nutrition',
                href: '/main/nutrition',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'nutrition:list'
              },
//              {
//                title: '食材原则',
//                name: 'dietGuidlineFoods',
//                href: '/main/dietGuidlineFoods',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'nutrition:list'
//              },
//              {
//                title: '患者食谱',
//                name: 'dietPlan',
//                href: '/main/dietPlan',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'dietPlan:list'
//                },
                {
                    title: '饮食原则',
                    name: 'dietGuidelines',
                    href: '/main/dietGuidelines',
                    closable: true,
                    showInTags: false,
                    showInMenus: true,
                    choosed: false,
                    enable: false,
                    permission: 'dietGuidelines:list'
                },
                {
                    title: '营养标准模板',
                    name: 'nutritionalGoals',
                    href: '/main/nutritionalGoals',
                    closable: true,
                    showInTags: false,
                    showInMenus: true,
                    choosed: false,
                    enable: false,
                    permission: 'nutritionalGoal:list'
                },
            ]
          },
          {
            title: '饮食管理',
            name: 'foodEat',
            icon: 'ios-restaurant',
            enable: false,
            children: [
              {
                title: '饮食日志',
                name: 'dietLog',
                href: '/main/dietLog',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'dietLog:list'
              },
              {
                title: '饮食分析',
                name: 'pcAnalyzeDietLog',
                href: '/main/pcAnalyzeDietLog',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'dietLog:analyzeDietLog'
              },
            ]
          },
          {
            title: '患者管理',
            name: 'user',
            icon: 'ios-contact',
            enable: false,
            children: [
              {
                title: '患者账户',
                name: 'username',
                href: '/main/user',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'user:list'
              },
              {
                title: '患者留言',
                name: 'message',
                href: '/main/message',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'message:list'
              },
              {
                title: '健康咨询',
                name: 'messagePro',
                href: '/main/messagePro',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'message:list'
              },
            ]
          },
          {
            title: '医生管理',
            name: 'doctors',
            icon: 'ios-pulse',
            enable: false,
            children: [
              {
                title:'医生管理',
                name:'doctor',
                href:'/main/doctor',
                closable:true,
                showInTags:false,
                showInMenus:true,
                choosed:false,
                enable: false,
                permission: 'doctor:list'
              },
              {
                title: '医助管理',
                name: 'dietitian',
                href: '/main/dietitian',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'dietitian:list'
              },
              // {
              //   title:'医生日程',
              //   name:'doctorSchedule',
              //   href:'/main/doctorSchedule',
              //   closable:true,
              //   showInTags:false,
              //   showInMenus:true,
              //   choosed:false,
              //   enable: false,
              //   permission: 'dietitian:list'
              // },
              {
                  title:'医生预约',
                  name:'doctorTime',
                  href:'/main/doctorTime',
                  closable:true,
                  showInTags:false,
                  showInMenus:true,
                  choosed:false,
                  permission: 'doctor:doctorTimeList'
              },
              {
                title:'预约管理',
                name:'doctorOrder',
                href:'/main/doctorOrder',
                closable:true,
                showInTags:false,
                showInMenus:true,
                choosed:false,
                enable: false,
                permission: 'doctor:order:list'
              },
              // {
              //     title:'医生咨询',
              //     name:'doctorIM',
              //     href:'doctorIM',
              //     closable:true,
              //     showInTags:false,
              //     showInMenus:true,
              //     choosed:false,
              //     permission: 'doctor:userSig:get'
              // },
            ]
          },
          {
            title: '药物管理',
            name: 'Medicine',
            icon: 'ios-medkit',
            enable: false,
            children: [
              {
                title: '药品管理',
                name: 'medicine',
                href: '/main/medicine',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'medicine:list'
              },
//              {
//                title: '营养素管理',
//                name: 'nutrient',
//                href: '/main/nutrient',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'nutrient:list'
//              },
            ]
          },
//          {
//            title: '诊疗管理',
//            name: 'diagnosis',
//            icon: 'md-analytics',
//            children: [
//              {
//                title: '食谱管理',
//                name: 'dietPlan',
//                href: '/main/dietPlan',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'dietPlan:list'
//              },
////              {
////                title: '病历管理',
////                name: 'medicalRecord',
////                href: '/main/medicalRecord',
////                closable: true,
////                showInTags: false,
////                showInMenus: true,
////                choosed: false,
////                permission: 'case:list'
////              },
////              {
////                title: '医嘱管理',
////                name: 'doctorAdvice',
////                href: '/main/doctorAdvice',
////                closable: true,
////                showInTags: false,
////                showInMenus: true,
////                choosed: false,
////                permission: 'doctorAdvice:list'
////              },
////              {
////                title: '处方管理',
////                name: 'prescription',
////                href: '/main/prescription',
////                closable: true,
////                showInTags: false,
////                showInMenus: true,
////                choosed: false,
////                permission: 'prescription:list'
////              },
//            ]
//          },
          {
            title: '模板管理',
            name: 'template',
            icon: 'logo-buffer',
            enable: false,
            children: [
//              {
//                title: '营养标准模板',
//                name: 'nutritionalGoals',
//                href: '/main/nutritionalGoals',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'nutritionalGoal:list'
//              },
//              {
//                title: '饮食原则模板',
//                name: 'dietGuidelines',
//                href: '/main/dietGuidelines',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'dietGuidelines:list'
//              },
              {
                title: '食谱模板',
                name: 'dietPlanTemplate',
                href: '/main/dietPlanTemplate',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'dietPlan:template:list'
              },
            ]
          },
          {
            title: '检测检查',
            name: 'checkReportForms',
            icon: 'ios-albums',
            enable: false,
            children: [
              // {
              //     title:'过敏信息',
              //     name:'allergen',
              //     href:'allergen',
              //     closable:true,
              //     showInTags:false,
              //     showInMenus:true,
              //     choosed:false,
              //     permission: 'allergen:list'
              // },
              {
                title: '检查项目',
                name: 'medicalObject',
                href: '/main/medicalObject',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'test:list'
              },
              {
                title: '检查订单',
                name: 'medicalOrder',
                href: '/main/medicalOrder',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'test:order:list'
              },
              {
                title: '检查报告',
                name: 'medicalReport',
                href: '/main/medicalReport',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'medicalReport:list'
              },
            ]
          },
          {
            title: '问卷管理',
            name: 'questionnaires',
            icon: 'md-paper',
            enable: false,
            children: [
              {
                title: '问卷类型',
                name: 'questionnaire_type',
                href: '/main/questionnaire_type',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'questionnaire:type:list'
              },
              {
                title: '基本问卷',
                name: 'questionnaire',
                href: '/main/questionnaire',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'questionnaire:list'
              },
//              {
//                title: '问卷填写',
//                name: 'questionnaireWrite',
//                href: '/main/questionnaireWrite',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'questionaire:answer'
//              },
              {
                title: '问卷结果',
                name: 'questionnaireResult',
                href: '/main/questionnaireResult',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'questionaire:result:list'
              },
//              {
//                title: '问卷统计',
//                name: 'questionnaireStatistics',
//                href: '/main/questionnaireStatistics',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'questionaire:result:count'
//              },
//              {
//                title: '特殊问卷绑定',
//                name: 'questionnaire_bind',
//                href: '/main/questionnaire_bind',
//                closable: true,
//                showInTags: false,
//                showInMenus: true,
//                choosed: false,
//                permission: 'questionnaire:update'
//              },
            ]
          },
          {
            title: '文章分享',
            name: 'articles_trends',
            icon: 'ios-paper',
            enable: false,
            children: [
              {
                title: '文章分类管理',
                name: 'articleType',
                href: '/main/articleType',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'articleType:list'
              },
              {
                title: '文章管理',
                name: 'articles',
                href: '/main/articles',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'business:article:list'
              },
              {
                title: '饮食DIY分类管理',
                name: 'articleDIYType',
                href: '/main/articleDIYType',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'articleDIYType:list'
              },
              {
                title: '饮食DIY',
                name: 'articlesDIY',
                href: '/main/articlesDIY',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'business:article:list'
              },
              // {
              //     title:'患者分享',
              //     name:'share',
              //     href:'share',
              //     closable:true,
              //     showInTags:false,
              //     showInMenus:true,
              //     choosed:false,
              //     permission: 'user:listShare'
              // }
            ]
          },
          {
            title: '微信管理',
            name: 'weiXin',
            icon: 'ios-chatbubbles',
            enable: false,
            children: [
              {
                title: '微信推送',
                name: 'weiXinMessage',
                href: '/main/weiXinMessage',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'All'
              },
              // {
              //     title:'在线客服',
              //     name:'webIM',
              //     href:'webIM',
              //     closable:true,
              //     showInTags:false,
              //     showInMenus:true,
              //     choosed:false,
              //     permission: 'userSig:get'
              // },
            ]
          },
          {
            title: '统计分析',
            name: 'analysis',
            icon: 'md-paper',
            enable: false,
            children: [
              {
                title: '问卷统计',
                name: 'questionnaireStatistics',
                href: '/main/questionnaireStatistics',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'questionaire:result:count'
              },
            ]
          },
          {
            title: '系统管理',
            name: 'system',
            icon: 'md-settings',
            enable: false,
            children: [
              {
                title: '常见问题',
                name: 'simpleQuestion',
                href: '/main/simpleQuestion',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'SQA:list'
              },
              {
                title: '文件管理',
                name: 'files',
                href: '/main/files',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'file:list'
              },
              {
                title: '角色权限',
                name: 'permissionRole',
                href: '/main/permissionRole',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'system:permission:list'
              },
              {
                title: '后台用户',
                name: 'systemUser',
                href: '/main/systemUser',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'system:user:list'
              },
              {
                title: '登陆历史',
                name: 'systemUserLoginLog',
                href: '/main/systemUserLoginLog',
                closable: true,
                showInTags: false,
                showInMenus: true,
                choosed: false,
                enable: false,
                permission: 'system:user:loginLog'
              },
            ]
          },
        ],
        // ------------------------------  菜单操作结束  --------------------------------
        userPermission: {}
      }
    },
    computed: {
      // 筛选menus中选中的menu
      tags() {
        let tags = [];
        // 将menus中showInTags=true的标签放到tags数组中
        this.menus.forEach(menu => {
          if (menu.showInTags) {
            tags.push(menu);
          } else if (menu.children) {
            menu.children.forEach(child => {
              if (child.showInTags) {
                tags.push(child)
              }
            })
          }
        });
        // console.log('tags=>',tags)

        //标签数组排序，从小到到
        tags.sort((a, b) => {
          return (a.num - b.num)
        })
        return tags;
      },
      rotateIcon() {
        return [
          'menu-icon',
          this.isCollapsed ? 'rotate-icon' : ''
        ];
      },
      menuitemClasses() {
        return [
          'menu-item',
          this.isCollapsed ? 'collapsed-menu' : ''
        ]
      }
    },
    // ------------------------------  菜单操作开始  --------------------------------
    //刷新页面之后保存并选中最后一次菜单和标签
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 通过 `vm` 访问组件实例
        let activeMenuName = localStorage.activeMenuName;
        vm.activeMenuName = activeMenuName;

        let tags_last_num = vm.tags[vm.tags.length - 1].num;

        if (activeMenuName && activeMenuName.length != 0) {
          vm.menus.forEach(_menu => {
            if (activeMenuName == _menu.name) {
              _menu.choosed = true;
              _menu.showInTags = true;
              _menu.num = tags_last_num + 1;
            } else if (_menu.children) {
              _menu.children.forEach(child => {
                if (activeMenuName == child.name) {
                  child.choosed = true;
                  child.showInTags = true;
                  child.num = tags_last_num + 1;
                  vm.openMenuName = [_menu.name];
                }
              })
            } else {
              // 排除首页
              if (_menu.name != 'admin') {
                _menu.choosed = false;
                _menu.showInTags = false;
              } else {
                _menu.choosed = false;
              }
            }
          })
        }
        vm.$nextTick(() => {
          // console.log(vm.$refs.side_menu, 22)
          // vm.$refs.side_menu.updateOpened();
          // vm.$refs.side_menu.updateActiveName();
        });
      })
    },
    // ------------------------------  菜单操作结束  --------------------------------
    created() {
      // this.permissionMenus()
    },
      mounted () {
        this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
        // 根据权限处理子菜单的显示与否
        this.menus.forEach(menu => {
          if (menu.children) {
            menu.children.forEach(child => {
              child.enable = this.currentUser.permission.indexOf(child.permission) > -1
              if (child.enable) {
                menu.enable = true
              }
            })
          } else {
            menu.enable = this.currentUser.permission.indexOf(menu.permission) > -1
          }
        })
      },
    methods: {
      /*tags 滚动事件 */
      handlescroll(e) {
        var type = e.type
        let delta = 0
        if (type === 'DOMMouseScroll' || type === 'mousewheel') {
          delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
        }
        this.handleScroll(delta)
      },
      /*tags 滑动事件 */
      handleScroll(offset) {
        const outerWidth = this.$refs.scrollOuter.offsetWidth
        const bodyWidth = this.$refs.scrollBody.offsetWidth
        if (offset > 0) {
          this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
        } else {
          if (outerWidth < bodyWidth) {
            if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
              this.tagBodyLeft = this.tagBodyLeft
            } else {
              this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
            }
          } else {
            this.tagBodyLeft = 0
          }
        }
      },
      quit() {
        this.$http.post('system/logout').then(
          function (res) {
            let msg = res.body
            if (msg.success) {
              this.$Notice.success({title: '退出成功'});
              sessionStorage.setItem('currentUser', null)
              this.$store.commit('setSystemUser', null)
              this.$router.push('/')
            } else {
              this.$Notice.error({title: '退出失败', desc: msg.message});
            }
          }, function (res) {
            this.$Notice.error({title: '服务器异常，退出失败'});
          }
        )
      },
      clickNotice() {
        this.choosedMenu('notice');
      },
      collapsedSider() {
        this.$refs.sidebar.toggleCollapse();
      },
      // ------------------------------  菜单操作开始  --------------------------------
      closeTag(event, name) {
        // 判断该标签是否是选中状态
        // 如果是那么就要设置标签数组中最后一个标签成选中状态
        // 如果否那么就直接删除就好
        let is_choosed = false;
        this.menus.forEach((menu) => {
          if (menu.name == name) {
            is_choosed = menu.choosed;
            menu.showInTags = false;
          } else if (menu.children) {
            menu.children.forEach(child => {
              if (child.name == name) {
                is_choosed = child.choosed;
                child.showInTags = false;
              }
            })
          }
        })
        // 关闭标签并选中tags中最后一个标签高亮
        if (is_choosed) {
          let last_tag = this.tags[this.tags.length - 1];
          last_tag.choosed = true;
          this.$router.push(last_tag.href);
          this.activeMenuName = last_tag.name;
          localStorage.activeMenuName = this.activeMenuName;
        }
      },
      clickTag(tag) {
        this.tags.forEach(_tag => {
          if (_tag.name == tag.name) {
            _tag.choosed = true;
          } else {
            _tag.choosed = false;
          }
        })
        // 设置菜单选中name
        this.activeMenuName = tag.name;
        localStorage.activeMenuName = this.activeMenuName;
        // 刷新菜单
        this.$nextTick(() => {
          if (this.$refs.side_menu) {
            this.$refs.side_menu.updateActiveName()
          }
        });
        //点击tab跳转
        this.$router.push(`${tag.href}`);
      },
      choosedMenu(name) {
        // 获取标签数组最后一个元素的num
        let tags_last_num = this.tags[this.tags.length - 1].num;
        // 设置选中菜单name
        this.activeMenuName = name;
        localStorage.activeMenuName = this.activeMenuName;

        //根据name查找对应的菜单对象
        let menu = null;
        this.menus.forEach(_menu => {
          if (_menu.name == name) {
            // 只有不在tags数组中的元素才能设置num
            if (!_menu.showInTags) {
              _menu.num = tags_last_num + 1;
            }
            menu = _menu;
            _menu.showInTags = true;
            _menu.choosed = true;

          } else if (_menu.children) {
            _menu.children.forEach(child => {
              if (child.name == name) {
                // 只有不在tags数组中的元素才能设置num
                if (!_menu.showInTags) {
                  child.num = tags_last_num + 1;
                }
                menu = child;
                child.showInTags = true;
                child.choosed = true;

              } else {
                child.choosed = false;
              }
            })
          } else {
            _menu.choosed = false;
          }
        })
        this.$router.push(`${menu.href}`);
      },
      dropdownClick(name) {
        this.choosedMenu(name);
      },
      // ------------------------------  菜单操作结束  --------------------------------
      permissionMenus() {
        this.userPermission = {All: true}
        for (let i in this.$store.state.systemUser.permission) {
          this.userPermission[this.$store.state.systemUser.permission[i]] = true
        }
        for (let i = 1; i < this.menus.length; i++) {
          if (this.menus[i].children && this.menus[i].children.length > 0) {
            for (let j = 0; j < this.menus[i].children.length; j++) {
              let permission = this.menus[i].children[j].permission
              if (!permission || !this.userPermission[permission]) {
                this.menus[i].children.splice(j, 1)
                j--
              }
            }
          }
          if (!this.menus[i].children || this.menus[i].children.length <= 0) {
            this.menus.splice(i, 1)
            i--
          }
        }
      }
    }
  }
</script>

<style lang="postcss" scoped type="scss">
  @import '../assets/common.pcss';

  .ivu-btn-text:hover {
    background-color: rgba(255, 255, 255, .2) !important;
  }

  .ivu-layout.ivu-layout-has-sider {
    height: 100%;
  }

  .ivu-layout-sider {
    background: #fff;
    transition: none;
  }

  .ivu-layout-header {
    height: 60px;
    line-height: 60px;
  }

  .ivu-menu {
    height: calc(100% - 60px);
    overflow-y: auto;
  }

  .ivu-menu-item {
    white-space: nowrap;
  }

  .ivu-menu-submenu {
    white-space: nowrap;

  &
  .ivu-menu-submenu-title {
    white-space: nowrap;
  }

  }

  .dd-menu {
    width: 200px;
    min-width: 200px;
    height: 100%;

  &
  .ddi-wapper {
    display: flex;
    align-items: center;

  &
  .ddi-text {
    padding-left: 10px;
  }

  }
  }
  .admin-layout-container {
    position: absolute;
    width: 100%;
    height: 100%;

  &
  .layout {
    background: #f5f7f9;
    position: relative;
    overflow: hidden;
    height: 100%;

  &
  .sidebar {
    background: #fff;
  }

  &
  .dropdown-wrap {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    background: #fff;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
    z-index: 11;

  &
  .dw-content {
    height: 100%;

  &
  .dd-btn {
    width: 83px;
    margin-left: -5px;
    padding: 10px 0;
  }

  }
  }
  &
  .logo {
    width: auto;
    height: 60px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    border-bottom: 1px solid #363e4f;
    position: relative;
    padding-left: 20px;
    background: #0d58ab;

  &
  .logo-saiqu {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

  &
  .user-name {
    color: #fff;
    font-size: 16px;
    margin-left: 15px;
  }

  }

  }
  }
  &
  .layout-header-bar {
    background: #fff;
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: 20;
    width: 100%;

  &
  .header-wapper {
    display: flex;
    align-tems: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    box-shadow: 0 2px 1px 1px rgba(100, 100, 100, 0.1);
    background: #0e64c3;
    color: #fff;

  &
  .header-left {
    display: flex;
    align-items: center;

  &
  .header-title {
    font-size: 18px;
    font-weight: bold
  }

  }
  &
  .header-right {
    margin-right: 20px;

  &
  .btn-blue {
    color: #fff;
  }

  }
  }
  }

  &
  .main-content {
    width: 100%;
    height: calc(100% - 60px);
    position: relative;
    overflow: auto;

  &
  .main-layout-con {
    height: 100%;
    overflow: hidden;

  &
  .content-wrapper {
    overflow: auto;
    padding: 10px;
    position: relative;

  &
  .spinCls {
    width: 60px !important;
    height: 60px !important;

  &
  ::after {
    background: linear-gradient(#0d58ab, #0256ac);
  }

  }
  }
  &
  .tags-nav-wapper {
    background: #f0f0f0;
    height: 40px;
    min-height: 40px;
    padding: 0;

  &
  .tags-nav {
    height: 100%;
    width: 100%;
    position: relative;
    border-top: 1px solid #F0F0F0;
    border-bottom: 1px solid #F0F0F0;

  &
  .btn-con {
    position: absolute;
    top: 0px;
    height: 100%;
    background: #fff;
    padding-top: 3px;
    z-index: 10;
  }

  &
  button {
    padding: 6px 4px;
    line-height: 14px;
    text-align: center;
  }

  &
  .left-btn {
    left: 0px;
    border-right: 1px solid #F0F0F0;
  }

  &
  .right-btn {
    right: 0px;
    border-left: 1px solid #F0F0F0;
  }

  &
  .scroll-outer {
    position: absolute;
    left: 28px;
    right: 28px;
    top: 0;
    bottom: 0;
    box-shadow: 0px 0 3px 2px rgba(100, 100, 100, .1) inset;

  &
  .scroll-body {
    height: calc(100% - 1px);
    display: inline-block;
    padding: 1px 4px 0;
    position: absolute;
    overflow: visible;
    white-space: nowrap;
    transition: left .3s ease;

  .ivu-tag-dot-inner {
    transition: background .2s ease;
  }

  }
  }
  &
  .contextmenu {
    position: absolute;
    margin: 0;
    padding: 5px 0;
    background: #fff;
    z-index: 100;
    list-style-type: none;
    border-radius: 4px;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

  &
  li {
    margin: 0;
    padding: 5px 15px;
    cursor: pointer;

  &
  :hover {
    background: #eee;
  }

  }
  }
  }
  }
  }
  }

  &
  .layout-logo-left {
    width: 90%;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
  }

  &
  .menu-icon {
    cursor: pointer;
    transition: all .3s;
    margin: 0 20px 0;
  }

  &
  .rotate-icon {
    transform: rotate(-90deg);
  }

  &
  .menu-item {
    position: absolute;
    overflow: auto;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);

  &
  :after {
    width: 0;
  }

  &
  span {
    display: inline-block;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
  }

  &
  i {
    transform: translateX(0px);
    transition: font-size .2s ease, transform .2s ease;
    vertical-align: middle;
    font-size: 16px;
  }

  }
  &
  .collapsed-menu {

  &
  span {
    width: 0px;
    transition: width .2s ease;
  }

  &
  i {
    transform: translateX(5px);
    transition: font-size .2s ease .2s, transform .2s ease .2s;
    vertical-align: middle;
    font-size: 22px;
  }

  }
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 100px;
    background-color: #F5F5F5;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: rgba(0, 0, 0, .2);
  }

  /*滑块效果*/
  ::-webkit-scrollbar-thumb:hover {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px #f5f5f5;
    background: rgba(0, 0, 0, 0.3);
  }

</style>
